<template>
  <v-container v-if="access.includes(roles.users)">
    <v-card
      class="mx-auto set-height"
    >
      <v-card-title>
        <div class="primary--text">
          Users
        </div>
        <v-spacer />
        <v-col
          cols="12"
          sm="6"
          md="4"
        >
          <v-text-field
            v-model="search_input2"
            append-icon="mdi-magnify"
            label="Search"
            class="menu-items"
            @keydown.enter="OnSearchInput2"
          />
        </v-col>
        <v-btn
          color="primary"
          class="menu-items"
          @click="ShowEmployees()"
        >
          New User
        </v-btn>
      </v-card-title>
      <div>
        <v-data-table
          :headers="headers_users"
          :items="users"
          :loading="loading_users"
          :options.sync="options2"
          :server-items-length="total2"
          :loading-text="loading_text"
          disable-sort
          class="elevation-1 text-no-wrap"
        >
          <template v-slot:[`item.role`]="{ item }">
            <v-menu
              offset-y
              open-on-hover
            >
              <template v-slot:activator="{ attrs, on }">
                <v-chip
                  :color="GetRoleColor(item.role)"
                  text-color="#eee"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ item.role }}
                </v-chip>
              </template>
              <v-list v-if="access.includes(roles.users_manage)">
                <v-list-item>
                  <v-list-item-title>Change role to</v-list-item-title>
                </v-list-item>
                <v-divider />
                <template
                  v-for="i in user_roles"
                >
                  <v-list-item
                    v-if="item.role !== i.description"
                    :key="i.uid"
                    @click="ChangeRole(item, i)"
                  >
                    <v-icon>mdi-arrow-right-bold</v-icon>
                    <v-list-item-title>{{ i.description }}</v-list-item-title>
                  </v-list-item>
                </template>
              </v-list>
            </v-menu>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-chip
              class="ma-2"
              :color="item.email_verified_at === null ? 'warning' : (item.status === 'active' ? 'primary' : 'gray')"
              text-color="white"
            >
              {{ item.email_verified_at === null ? 'for verification' : item.status }}
            </v-chip>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              v-if="item.email_verified_at === null"
              small
              color="primary"
              @click.stop="SendVerification(item)"
            >
              Re-Send Verification
            </v-btn>
            <v-btn
              v-if="item.status == 'locked' && item.email_verified_at !== null"
              small
              color="primary"
              @click.stop="ReactivateUser(item)"
            >
              Re-Activate
            </v-btn>
            <v-btn
              small
              color="error"
              :class="{ 'ml-2': (item.email_verified_at === null || item.status == 'locked') }"
              @click.stop="ArchiveUser(item)"
            >
              Archive
            </v-btn>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-card
      class="mx-auto set-height"
    >
      <v-card-title>
        <div class="primary--text">
          Users Summary
        </div>
      </v-card-title>
      <div>
        <v-data-table
          :headers="headers_user_stats"
          :items="user_stats"
          :disable-sort="true"
          :loading="loading_user_stats"
          :loading-text="loading_text"
          class="elevation-1 text-no-wrap"
        />
      </div>
    </v-card>
    <div class="py-3" />
    <!-- User selection dialog -->
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="show_employees"
          width="90%"
          max-width="90%"
        >
          <v-card>
            <v-card-title class="text-left">
              <v-row>
                <h2 class="primary--text">
                  Managers
                </h2>
                <v-spacer />
                <v-col
                  cols="6"
                  sm="6"
                  md="4"
                >
                  <v-text-field
                    v-model="search_input"
                    append-icon="mdi-magnify"
                    label="Search"
                    class="menu-items"
                    @keydown.enter="OnSearchInput"
                  />
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="headers_employees"
                :items="employees"
                :disable-sort="true"
                :options.sync="options"
                :server-items-length="total"
                :loading="loading_employees"
                :loading-text="loading_text"
                class="elevation-1 text-no-wrap"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <div class="row">
                    <v-btn
                      small
                      color="primary"
                      :disabled="item.email !== null"
                      @click.stop="SelectUser(item)"
                    >
                      Select
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn
                color="green darken-1"
                text
                @click="show_employees = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!-- End user selection dialog -->
    <!-- New User dialog -->
    <v-dialog
      v-model="show_new_userform"
      width="40%"
      max-width="40%"
    >
      <v-card>
        <v-card-title class="text-left">
          <h2 class="primary--text">
            Input Email & Role
          </h2>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="new_userform"
            lazy-validation
          >
            <v-col
              cols="12"
            >
              <v-text-field
                ref="email"
                v-model="email"
                label="GADC Email Only"
                :rules="[
                  v => !!v || 'This is required'
                ]"
                @keydown.enter="$refs.role.focus()"
              />
              <v-select
                ref="role"
                v-model="role"
                label="Role"
                :items="user_roles"
                item-text="description"
                item-value="uid"
                :loading="loading_roles"
                :rules="[
                  v => !!v || 'This is required'
                ]"
              />
            </v-col>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            :disabled="in_process"
            @click="CreateUser"
          >
            Add User
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="in_process"
            @click="show_new_userform = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End New User dialog -->
    <confirm ref="confirm" />
  </v-container>
</template>
<script>
  import {
    mapState,
  } from 'vuex'
  import { RegisterUser, SendVerification } from '@/graphql/Auth.gql'
  import {
    Employees,
  } from '@/graphql/Employee.gql'
  import {
    GetUsers,
    ArchiveUser,
    ReactivateUser,
    GetRoles,
    ChangeRole,
    GetUserStats,
  } from '@/graphql/User.gql'
  export default {
    components: {
      Confirm: () => import('@/views/dashboard/component/Confirm'),
      // rebuild
    },
    data () {
      return {
        users: [],
        employees: [],
        loading_text: 'Please wait while loading data...',
        headers_users: [
          { text: 'Store', value: 'store_name', class: 'title' },
          { text: 'PERSONNELIDNO', value: 'personnelidno', class: 'title' },
          { text: 'Name', value: 'name', class: 'title' },
          { text: 'Position', value: 'position', class: 'title' },
          { text: 'Role', value: 'role', class: 'title', align: 'center' },
          { text: 'Email', value: 'email', class: 'title' },
          { text: 'Account', value: 'status', class: 'title', align: 'center', filterable: true },
          { text: 'Date Created', value: 'created_at', class: 'title' },
          { text: 'Employment Status', value: 'employment_status', class: 'title' },
          { text: 'Last Active', value: 'last_active', class: 'title' },
          { text: 'Actions', value: 'actions', class: 'title' },
        ],
        headers_employees: [
          { text: 'Store', value: 'store_name', class: 'title' },
          { text: 'PERSONNELIDNO', value: 'personnelidno', class: 'title' },
          { text: 'Last Name', value: 'last_name', class: 'title' },
          { text: 'First Name', value: 'first_name', class: 'title' },
          { text: 'Middle Name', value: 'middle_name', class: 'title' },
          { text: 'Nick Name', value: 'nick_name', class: 'title' },
          { text: 'Position', value: 'position_code', class: 'title' },
          { text: 'Employment Status', value: 'employment_status', class: 'title' },
          { text: 'Actions', value: 'actions', class: 'title' },
        ],
        headers_user_stats: [
          { text: 'Role', value: 'description', class: 'title' },
          { text: 'For Verification', value: 'for_verification', class: 'title' },
          { text: 'Active This Month', value: 'active_this_month', class: 'title' },
          { text: 'Idle', value: 'idle', class: 'title' },
          { text: 'Locked', value: 'locked', class: 'title' },
          { text: 'Archive', value: 'archive', class: 'title' },
        ],
        show_employees: false,
        loading_users: true,
        loading_employees: true,
        skip_users: true,
        skip_employees: true,
        is_saving: false,
        search: '',
        search_input: '',
        total: 0,
        search2: '',
        search_input2: '',
        total2: 0,
        uid: '',
        email: '',
        show_new_userform: false,
        options: {
          page: 1,
          itemsPerPage: 10,
        },
        options2: {
          page: 1,
          itemsPerPage: 10,
        },
        employees_hash: '',
        users_hash: '',
        load_employees: false,
        role: '',
        user_roles: [],
        loading_roles: true,
        skip_roles: true,
        user_stats: [],
        loading_user_stats: true,
        skip_user_stats: true,
        roles_hash: '',
      }
    },
    computed: {
      ...mapState(['in_process', 'default_error', 'access', 'roles']),
      RoleColors () {
        return ['blue-grey', 'primary', 'info', 'warning', 'teal', 'purple', 'brown', 'grey']
      },
    },
    watch: {
      options: {
        handler () {
          this.GetEmployees()
        },
        deep: true,
      },
      options2: {
        handler () {
          this.GetUsers()
        },
        deep: true,
      },
    },
    mounted () {
      window.scrollTo(0, 0)
      this.GetRoles()
      this.GetUserStats()
    },
    methods: {
      ShowEmployees () {
        if (!this.access.includes(this.roles.users_manage)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.show_employees = true
      },
      GetRoleColor (item) {
        const c = this.RoleColors[this.user_roles.map(function (e) { return e.description }).indexOf(item)]
        return (typeof c === 'undefined') ? '' : c
      },
      ChangeRole (user, role) {
        this.$store.commit('Notify', 'Please wait...')
        this.$apollo.mutate({
          mutation: ChangeRole,
          variables: {
            uid: user.uid,
            hash: this.users_hash,
            role: role.uid,
            role_hash: this.roles_hash,
          },
        }).then((res) => {
          if (res.data) {
            if (res.data.ChangeRole.status === 'Ok') {
              this.$store.commit('CloseAlert', '')
              user.role = role.description
            } else if (res.data.ChangeRole.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            } else {
              this.$store.commit('ShowError', res.data.ChangeRole.status)
            }
          }
        }).catch(error => {
          this.CheckError(error)
        })
      },
      SendVerification (item) {
        if (!this.access.includes(this.roles.users_manage)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.$store.commit('Notify', 'Sending verification...')
        this.$apollo.mutate({
          mutation: SendVerification,
          variables: {
            uid: item.uid,
            hash: this.users_hash,
          },
        }).then((res) => {
          if (res.data) {
            if (res.data.SendVerification === 'Ok') {
              this.$store.commit('CloseAlert', 'Verification sent!')
            } else if (res.data.SendVerification.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            } else {
              this.$store.commit('ShowError', res.data.SendVerification)
            }
          }
        }).catch(error => {
          this.CheckError(error)
        })
      },
      ArchiveUser (item) {
        if (!this.access.includes(this.roles.users_manage)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.$refs.confirm.open('Please Confirm!', 'You are going to archive user: ' + item.name + '!', { color: 'red' })
          .then((confirm) => {
            if (confirm) {
              this.$store.commit('Notify', 'Archiving user...')
              this.$apollo.mutate({
                mutation: ArchiveUser,
                variables: {
                  uid: item.uid,
                  hash: this.users_hash,
                },
              }).then((res) => {
                if (res.data) {
                  if (res.data.ArchiveUser.status === 'Ok') {
                    this.$store.commit('CloseAlert', 'User has been archived!')
                    this.users = res.data.ArchiveUser.data
                    this.users_hash = res.data.ArchiveUser.hash
                  } else if (res.data.ArchiveUser.status === '0') {
                    this.CheckError({ message: 'Session expired!' })
                  } else {
                    this.$store.commit('ShowError', res.data.ArchiveUser.status)
                  }
                }
              }).catch(error => {
                this.CheckError(error)
              })
            }
          })
      },
      ReactivateUser (item) {
        if (!this.access.includes(this.roles.users_manage)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.$refs.confirm.open('Please Confirm!', 'You are going to re-activate user: ' + item.name + '!', { color: 'red' })
          .then((confirm) => {
            if (confirm) {
              this.$store.commit('Notify', 'Re-activating user...')
              this.$apollo.mutate({
                mutation: ReactivateUser,
                variables: {
                  uid: item.uid,
                  hash: this.users_hash,
                },
              }).then((res) => {
                if (res.data) {
                  if (res.data.ReactivateUser.status === 'Ok') {
                    this.$store.commit('CloseAlert', 'User has been re-activated!')
                    this.users = res.data.ReactivateUser.data
                    this.users_hash = res.data.ReactivateUser.hash
                  } else if (res.data.ReactivateUser.status === '0') {
                    this.CheckError({ message: 'Session expired!' })
                  } else {
                    this.$store.commit('ShowError', res.data.ReactivateUser.status)
                  }
                }
              }).catch(error => {
                this.CheckError(error)
              })
            }
          })
      },
      SelectUser (i) {
        this.uid = i.uid
        this.email = ''
        this.role = ''
        this.show_new_userform = true
        setTimeout(() => {
          this.$refs.new_userform.resetValidation()
          this.$refs.email.focus()
        }, 0)
      },
      CreateUser () {
        if (!this.$refs.new_userform.validate()) {
          this.$store.commit('ShowError', 'Please check your input!')
          return
        }
        this.$store.commit('Notify', 'Creating user access...')
        this.$apollo.mutate({
          mutation: RegisterUser,
          variables: {
            uid: this.uid,
            hash: this.employees_hash,
            email: this.email,
            role: this.role,
            role_hash: this.roles_hash,
          },
        }).then((res) => {
          if (res.data.RegisterUser.status === 'Ok') {
            this.$store.commit('CloseAlert', 'New user has been added!')
            this.show_new_userform = false
            this.show_employees = false
            this.load_employees = true
            this.GetUsers()
          } else if (res.data.RegisterUser.status === '0') {
            this.CheckError({ message: 'Session expired!' })
          } else {
            this.$store.commit('ShowError', res.data.RegisterUser.status)
          }
        }).catch(error => {
          this.CheckError(error)
          this.show_new_userform = false
        })
      },
      OnSearchInput (e) {
        this.search = this.search_input
        this.options.page = 1
        this.GetEmployees()
      },
      OnSearchInput2 (e) {
        this.search2 = this.search_input2
        this.options2.page = 1
        this.GetUsers()
      },
      GetUsers () {
        if (!this.access.includes(this.roles.users)) { return }
        this.loading_users = true
        this.users = []
        this.skip_users = false
      },
      GetEmployees () {
        this.loading_employees = true
        this.employees = []
        this.skip_employees = false
      },
      GetRoles () {
        this.loading_roles = true
        this.user_roles = []
        this.skip_roles = false
      },
      GetUserStats () {
        this.loading_user_stats = true
        this.user_stats = []
        this.skip_user_stats = false
      },
    },
    apollo: {
      GetUsers: {
        error (error) {
          this.loading_users = false
          this.CheckError(error)
        },
        query: GetUsers,
        variables () {
          return {
            per_page: this.options2.itemsPerPage || 10,
            page: this.options2.page || 1,
            search: this.search2,
          }
        },
        skip () {
          return this.skip_users
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetUsers.status === 'Ok') {
              this.users = data.GetUsers.data
              this.users_hash = data.GetUsers.hash
              this.total2 = data.GetUsers.total
            } else if (data.GetUsers.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            }
            this.loading_users = false
            this.skip_users = true
            if (this.load_employees) { this.GetEmployees() }
          }
        },
      },
      Employees: {
        error (error) {
          this.loading_employees = false
          this.CheckError(error)
        },
        query: Employees,
        variables () {
          return {
            per_page: this.options.itemsPerPage || 10,
            page: this.options.page || 1,
            search: this.search,
          }
        },
        skip () {
          return this.skip_employees
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data.Employees.status === 'Ok') {
              this.employees = data.Employees.data
              this.employees_hash = data.Employees.hash
              this.total = data.Employees.total
            } else if (data.Employees.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            } else {
              this.$store.commit('ShowError', data.Employees.status)
            }
            this.loading_employees = false
            this.skip_employees = true
            this.load_employees = false
          }
        },
      },
      GetRoles: {
        error (error) {
          this.loading_roles = false
          this.CheckError(error)
        },
        query: GetRoles,
        variables () {
          return {
          }
        },
        skip () {
          return this.skip_roles
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data.GetRoles.status === 'Ok') {
              this.user_roles = data.GetRoles.data
              this.roles_hash = data.GetRoles.hash
            }
            this.loading_roles = false
            this.skip_roles = true
          }
        },
      },
      GetUserStats: {
        error (error) {
          this.loading_user_stats = false
          this.CheckError(error)
        },
        query: GetUserStats,
        variables () {
          return {
          }
        },
        skip () {
          return this.skip_user_stats
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data.GetUserStats.status === 'Ok') {
              this.user_stats = data.GetUserStats.data
            }
            this.loading_user_stats = false
            this.skip_user_stats = true
          }
        },
      },
    },
  }
</script>
